'use client';

import { useEffect, useState, type FormEvent } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function MobileReviewerSignin() {
  const [native, setNative] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const detect = () => setNative((window as Window & { UpsideNativeIntercom?: { version: number } }).UpsideNativeIntercom?.version === 1);
    detect();
    window.addEventListener('upside-intercom-ready', detect);
    return () => window.removeEventListener('upside-intercom-ready', detect);
  }, []);
  if (!native) return null;
  async function submit(event: FormEvent) {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const response = await fetch('/api/auth/mobile-reviewer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      setPassword('');
      if (!response.ok) {
        setError('Unable to sign in. Check the reviewer credentials and try again.');
        return;
      }
      window.location.assign('/odds-screen');
    } catch {
      setError('Unable to connect. Please try again.');
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="mt-4 w-full max-w-md" data-ph-mask>
      <Button variant="ghost" className="w-full" aria-expanded={expanded} onClick={() => setExpanded(!expanded)} disabled={busy}>
        Reviewer sign-in
      </Button>
      {expanded && (
        <form onSubmit={submit} className="space-y-4 rounded-panel border border-white/10 bg-surface-raised p-6">
          <p className="text-sm text-muted-foreground">Use the dedicated account provided in the App Review instructions.</p>
          <div>
            <Label htmlFor="reviewer-email">Reviewer email</Label>
            <Input id="reviewer-email" type="email" autoComplete="username" value={email} onChange={event => setEmail(event.target.value)} required disabled={busy} />
          </div>
          <div>
            <Label htmlFor="reviewer-password">Reviewer password</Label>
            <Input id="reviewer-password" type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required maxLength={256} disabled={busy} />
          </div>
          {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" className="w-full" disabled={busy}>{busy ? 'Signing in…' : 'Sign in as reviewer'}</Button>
        </form>
      )}
    </section>
  );
}
